import React, { useState, useEffect } from 'react';
import { FaMoneyBillAlt } from 'react-icons/fa';
import { CgProfile } from 'react-icons/cg';
import './salary.css';
import axios from 'axios';


export default function Salary() {
  const [salary, setSalary] = useState(null);  // Use null initially to indicate loading state
  const [username, setUsername] = useState('');  // State to store username
  const [loading, setLoading] = useState(true);  // State to track loading status

  // Fetch salary data when component mounts
  useEffect(() => {
    const fetchSalaryData = async () => {
      try {
        const userId = localStorage.getItem('userId');  // Get the userId from localStorage
        const storedUsername = localStorage.getItem('name');  // Get the username from localStorage

        if (!userId) {
          console.log('User is not logged in');
          return;
        }

        // Set the username from localStorage
        setUsername(storedUsername);

        // Fetch user details including name and salary using userId
        const response = await axios.get(`https://backend.ems.hiradentallab.com/api/user/salary/${userId}`);
        setSalary(response.data.salary);  // Assuming the response contains the salary

      } catch (error) {
        console.error('Error fetching salary:', error);
      } finally {
        setLoading(false);  // Stop loading once the data is fetched or error occurs
      }
    };

    fetchSalaryData();
  }, []);
  return (
    <div>
      <div className='container-salary'>
        <h1 className="salary-title">
          <FaMoneyBillAlt className="salary-icon" /> My Salary
        </h1>
        <hr />
        <h2 className="salary-subtitle">
          <CgProfile className="salary-icon" /> {loading ? 'Loading...' : username ? ` ${username}!` : 'Welcome, Guest!'}  {/* Display the name if available */}
        </h2>
        <hr />
        <div className="table-container">
          <div className="table-responsive">
            <table className="table table-striped table-style">
              <thead className="salary-table-header">
                <tr>
                  <th>SR</th>
                  <th>Name</th>
                  <th>Salary</th>
                </tr>
              </thead>
              <tbody>
                {salary !== null ? (
                  <tr>
                    <td>1</td> {/* Always 1 since it's a single employee */}
                    <td>{username ? ` ${username}` : 'Welcome, Guest!'}</td> {/* Display the user's name */}
                    <td>{salary}</td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No salary data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
